import { action, makeObservable, observable } from 'mobx';
import utilsService from '../services/UtilsService';

export class DrawManager {
  constructor() {
    makeObservable(this);
  }

  @observable textContainers = {};
  toolbarUiByLessonElementId = {};

  dragProps = null;
  lessonElementId = null;

  getToolbarUi(lessonElementId) {
    return this.toolbarUiByLessonElementId[lessonElementId] || null;
  }

  setToolbarUi(lessonElementId, ui) {
    if (!lessonElementId) {
      return;
    }
    this.toolbarUiByLessonElementId[lessonElementId] = ui;
  }

  // prevent data for a previous slide from being used in the current slide
  @action init(lessonElementId) {
    if (this.lessonElementId !== lessonElementId) {
      this.lessonElementId = lessonElementId;
      if (!this.textContainers[lessonElementId]) {
        this.textContainers[lessonElementId] = [];
      }
      this.dragProps = null;
    }
  }

  @action addTextContainer(textContainer, lessonElementId) {
    this.textContainers[lessonElementId].push(textContainer);
  }

  @action initializeTextContainers(textModels, lessonElementId) {
    const textContainers = [];
    this.textContainers[lessonElementId] = [];

    if (!textModels) {
      return;
    }

    textModels.forEach((textModel) => {
      const textContainer = {
        textId: textModel.id,
        top: textModel.position.top,
        left: textModel.position.left,
        text: textModel.text,
        lessonElementId,
        opacity: 1,
      };
      textContainers.push(textContainer);
    });

    this.textContainers[lessonElementId] = textContainers;
  }

  @action setTextContainerText(textId, data, lessonElementId) {
    const textContainer = this.textContainers[lessonElementId].find((container) => container.textId === textId);
    textContainer.text = data;
  }

  findTextContainer(textId, lessonElementId) {
    const textContainer = this.textContainers[lessonElementId].find((container) => container.textId === textId);
    return textContainer;
  }

  @action deleteTextContainer(textId, lessonElementId) {
    const newTextContainers = this.textContainers[lessonElementId].filter((container) => container.textId !== textId);
    this.textContainers[lessonElementId] = newTextContainers;
  }

  @action dragStartTextContainer(textId, clientX, clientY, width, height, lessonElementId) {
    this.dragProps = {
      textId,
      clientX,
      clientY,
      width,
      height,
    };
    const textContainer = this.findTextContainer(this.dragProps.textId, lessonElementId);
    textContainer.opacity = 0.5;
  }

  @action dropTextContainer(clientX, clientY, lessonElementId, maxWidth = 600, maxHeight = 600) {
    if (this.dragProps) {
      // const textContainer = this.textContainers.find((container) => container.textId === this.dragProps.textId);
      const textContainer = this.findTextContainer(this.dragProps.textId, lessonElementId);

      let left = clientX - this.dragProps.clientX + textContainer.left;
      let top = clientY - this.dragProps.clientY + textContainer.top;

      // adjust if dropped outside the container (bounds match the drawing overlay / canvas area)
      if (left < 0) {
        left = 0;
      }
      if (left + this.dragProps.width > maxWidth) {
        left = maxWidth - this.dragProps.width;
      }
      if (top < 0) {
        top = 0;
      }
      if (top + this.dragProps.height > maxHeight) {
        top = maxHeight - this.dragProps.height;
      }

      textContainer.left = left;
      textContainer.top = top;
      textContainer.opacity = 1;
      this.dragProps = null;
    }
  }
}

export default new DrawManager();
